// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../node_modules/css-loader/dist/runtime/api.js";
import ___CSS_LOADER_GET_URL_IMPORT___ from "../../node_modules/css-loader/dist/runtime/getUrl.js";
var ___CSS_LOADER_URL_IMPORT_0___ = new URL("data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E", import.meta.url);
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
var ___CSS_LOADER_URL_REPLACEMENT_0___ = ___CSS_LOADER_GET_URL_IMPORT___(___CSS_LOADER_URL_IMPORT_0___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* ============================================
   MODEL BUILDER OVERLAY STYLES
   ============================================ */

/* Overlay Container */
.model-builder-overlay {
    position: fixed;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    z-index: 1000;
    display: flex;
    align-items: center;
    justify-content: center;
}

/* Semi-transparent backdrop */
.model-builder-backdrop {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background: rgba(0, 0, 0, 0.4);
    /* Lighter backdrop per design */
    backdrop-filter: blur(1px);
}

/* Main container */
.model-builder-container {
    position: relative;
    display: flex;
    gap: 2rem;
    width: 90%;
    max-width: 1500px;
    margin: 0 auto;
    height: 90vh;
    /* Taller for better view */
    max-height: 900px;
    z-index: 1;
}

/* Glassmorphism Base Utility */
.glass-ui-box {
    background: var(--surface-glass);
    backdrop-filter: blur(4px);
    -webkit-backdrop-filter: blur(5px);
    border: 1px solid var(--border-default);
    box-shadow: -2px 0 2px rgba(255, 255, 255, 0.1),
        2px 0 2px rgba(255, 255, 255, 0.1),
        inset 0 1px 0 rgba(255, 255, 255, 0.05);
}

/* ============================================
   LEFT PANEL - COMPONENT SEARCH
   ============================================ */
.component-search-panel {
    width: 400px;
    min-width: 400px;
    background: transparent;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: var(--radius-3xl);
    padding: var(--space-xl);
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-glass);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
}

.panel-title {
    font-size: var(--font-size-base);
    font-weight: 700;
    color: var(--color-text-primary);
    margin: 0 0 1.25rem 0;
    letter-spacing: 0.5px;
    text-transform: uppercase;
}

/* Pill Tabs Selector */
.panel-tabs {
    display: flex;
    background: var(--surface-input);
    border-radius: var(--radius-pill);
    padding: 3px;
    margin-bottom: 1.25rem;
    border: 1px solid var(--border-strong);
}

.panel-tab {
    flex: 1 1;
    padding: var(--space-sm) var(--space-lg);
    background: transparent;
    border: none;
    color: var(--color-text-dim);
    font-size: var(--font-size-base);
    font-weight: 500;
    cursor: pointer;
    transition: var(--transition-normal);
    border-radius: 30px;
}

.panel-tab.active {
    background: var(--border-default);
    backdrop-filter: blur(10px);
    color: var(--color-text-primary);
    border: 1px solid var(--border-default);
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

.panel-tab:not(.active):hover {
    color: var(--color-text-secondary);
    background: var(--surface-subtle);
}

/* Search */
.panel-search {
    position: relative;
    margin-bottom: 1.25rem;
}

.panel-search .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: var(--color-text-faint);
    width: 14px;
    height: 14px;
}

.panel-search .search-input {
    width: 100%;
    padding: 0.55rem var(--space-lg) 0.55rem 2.25rem;
    background: var(--surface-input);
    border: 1px solid var(--border-medium);
    border-radius: var(--radius-pill);
    color: var(--color-text-primary);
    font-size: var(--font-size-base);
    outline: none;
    transition: var(--transition-fast);
}

.panel-search .search-input:focus {
    border-color: rgba(139, 92, 246, 0.5);
    background: rgba(51, 51, 51, 0.4);
}

/* Items List */
.panel-items {
    flex: 1 1;
    overflow-y: auto;
    display: flex;
    flex-direction: column;
    gap: 0.6rem;
    padding-right: 4px;
}

/* Glass card row — matches Figma overlay design */
.panel-item {
    padding: 0.85rem 1.25rem;
    background: rgba(0, 0, 0, 0.15);
    border: 1px solid var(--border-strong);
    border-radius: var(--radius-2xl);
    cursor: pointer;
    transition: var(--transition-fast);
    display: flex;
    align-items: center;
    gap: var(--space-sm);
}

.panel-item:hover {
    background: rgba(255, 255, 255, 0.08);
    border-color: var(--color-text-dim);
    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);
}

/* Product items with image placeholder */
.item-visual {
    width: 40px;
    height: 40px;
    border-radius: var(--radius-md);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-shrink: 0;
}

.item-visual__image {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    object-fit: cover;
}

.item-visual__placeholder {
    width: 36px;
    height: 36px;
    border-radius: 6px;
    background: rgba(139, 92, 246, 0.2);
    display: flex;
    align-items: center;
    justify-content: center;
}

.item-info {
    flex: 1 1;
    display: flex;
    flex-direction: column;
}

.item-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    width: 100%;
}

.item-name {
    font-size: var(--font-size-base);
    font-weight: 600;
    color: var(--color-text-primary);
    line-height: 1.3;
    flex: 1 1;
    min-width: 0;
    word-break: break-word;
    padding-right: var(--space-lg);
}

.item-price-stack {
    text-align: center;
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    border-left: 1px solid rgba(255, 255, 255, 0.2);
    padding-left: var(--space-lg);
    width: 110px;
    flex-shrink: 0;
}

.item-price {
    font-size: var(--font-size-base);
    font-weight: 600;
    color: var(--color-text-primary);
}

.item-unit {
    font-size: 11px;
    color: var(--color-text-faint);
}

.empty-search {
    color: var(--color-text-faint);
    text-align: center;
    padding: var(--space-lg);
}

.load-more-btn {
    width: 100%;
    padding: 0.75rem;
    margin-top: var(--space-sm);
    background: rgba(255, 255, 255, 0.1);
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: 6px;
    color: var(--color-text-muted);
    cursor: pointer;
    font-size: var(--font-size-md);
}

.item-type-indicator {
    display: inline-flex;
    align-items: center;
    gap: 0.3rem;
    font-size: var(--font-size-xs);
    color: var(--color-text-faint);
    margin-top: 4px;
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

/* ============================================
   RIGHT PANEL - MODEL BUILDER (GLASS BORDER WRAPPER)
   ============================================ */
.model-builder-main {
    flex: 1 1;
    background: transparent;
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    border-radius: var(--radius-3xl);
    display: flex;
    flex-direction: column;
    border: 1px solid var(--border-glass);
    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);
    position: relative;
}

.model-builder-header {
    display: flex;
    align-items: center;
    justify-content: space-between;
    margin-bottom: var(--space-xl);
}

.model-builder-title {
    font-size: 1.2rem;
    font-weight: 800;
    color: var(--color-text-primary);
    margin: 0;
    letter-spacing: 1px;
    text-transform: uppercase;
}

/* Base Pill Inputs (Text/Number/Select) */
.glass-pill-input,
.glass-pill-select {
    background: var(--surface-input);
    border: 1px solid var(--border-medium);
    border-radius: var(--radius-2xl);
    padding: var(--space-sm) var(--space-lg);
    color: var(--color-text-primary);
    font-size: var(--font-size-base);
    outline: none;
    width: 100%;
    transition: var(--transition-fast);
    appearance: none;
    -webkit-appearance: none;
}

.glass-pill-input:focus,
.glass-pill-select:focus {
    border-color: var(--border-glass);
    background: var(--surface-input-focus);
}

.glass-pill-select {
    cursor: pointer;
    background-image: url(${___CSS_LOADER_URL_REPLACEMENT_0___});
    background-repeat: no-repeat;
    background-position: right 0.7rem top 50%;
    background-size: 0.65rem auto;
    padding-right: 2rem;
}

.glass-pill-select option {
    background-color: var(--surface-dark-gradient-start);
    color: var(--color-text-primary);
    padding: var(--space-sm);
}

/* Currency Wrapper with Icon */
.currency-pill-wrapper {
    position: relative;
    display: flex;
    align-items: center;
}

.currency-icon-dot {
    position: absolute;
    left: var(--space-sm);
    width: 16px;
    height: 16px;
    background: var(--color-accent-yellow);
    border-radius: var(--radius-circle);
    display: flex;
    align-items: center;
    justify-content: center;
    color: var(--color-text-primary);
    font-size: var(--font-size-xs);
    font-weight: bold;
    z-index: 1;
    pointer-events: none;
}

.currency-pill-wrapper .glass-pill-select {
    padding-left: 2rem; /* Make room for yellow icon */
}

/* Labels */
.form-group {
    display: flex;
    flex-direction: column;
    gap: 0.4rem;
}

.form-label {
    font-size: var(--font-size-sm);
    font-weight: 500;
    color: var(--color-text-faint);
    text-transform: capitalize;
    margin-left: var(--space-sm);
}

.form-label-mini {
    font-size: 0.7rem;
    color: var(--color-text-muted);
    font-weight: 500;
    text-transform: capitalize;
    margin-left: var(--space-sm);
}

.form-label-mini--sub {
    display: block;
    margin-bottom: 4px;
    margin-left: 0;
    font-size: 0.65rem;
    color: var(--color-text-faint);
    text-transform: uppercase;
}

/* Main Product Card Styling (Header Area) */
.model-builder-product-row {
    display: flex;
    flex-direction: column;
    gap: 0;
    margin-bottom: var(--space-2xl);
    border-bottom: solid 1px var(--border-default);
    border-radius: 0 0 14px 14px;
    background: var(--surface-subtle);
    padding: var(--space-2xl);
}

.product-top-row {
    display: flex;
    gap: var(--space-xl);
    align-items: flex-end;
    width: 100%;
}

.product-image-container {
    width: 80px;
    height: 80px;
    flex-shrink: 0;
}

.product-image-placeholder {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.07);
    border-radius: var(--radius-lg);
    border: 1px solid var(--border-default);
    display: flex;
    align-items: center;
    justify-content: center;
    overflow: hidden;
}

.product-image-placeholder--clickable {
    cursor: pointer;
    position: relative;
}

.product-image-preview {
    width: 100%;
    height: 100%;
    object-fit: cover;
    border-radius: inherit;
}

.product-image-upload-hint {
    width: 100%;
    height: 100%;
    background: rgba(255, 255, 255, 0.05);
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    gap: 4px;
}

.product-name-section {
    display: flex;
    flex-direction: column;
    gap: var(--space-lg);
    flex: 1 1;
}

.form-group {
    display: flex;
    flex-direction: column;
    gap: var(--space-sm);
}

.form-group--flex {
    flex: 1 1;
}

.form-group--w-70 {
    width: 70px;
}

.form-group--w-90 {
    width: 90px;
}

.form-group--w-120 {
    width: 120px;
}

.product-bottom-row {
    margin-top: 0.75rem;
    padding-left: 92px;
}

.form-label {
    font-size: var(--font-size-sm);
    font-weight: 600;
    color: var(--color-text-faint);
    text-transform: uppercase;
    letter-spacing: 0.5px;
}

.glass-input-main {
    background: var(--surface-input);
    border: 1.5px solid var(--border-subtle);
    border-radius: var(--radius-lg);
    padding: var(--space-md) var(--space-lg);
    color: var(--color-text-primary);
    font-size: var(--font-size-xl);
    outline: none;
    transition: var(--transition-fast);
    width: 100%;
}

.glass-input-main--inline {
    font-size: 1rem;
    padding: var(--space-sm);
    background: transparent;
    border: none;
    color: var(--color-text-primary);
    width: 100%;
}

.glass-input-main:focus {
    border-color: rgba(255, 255, 255, 0.2);
    background: var(--surface-input-focus);
}

.product-controls-grid {
    display: flex;
    gap: var(--space-lg);
    align-items: flex-end;
}

/* ============================================
   TABLE & SUB-PRODUCT CARDS
   ============================================ */
.model-builder-table-container {
    flex: 1 1;
    overflow-y: auto;
    overflow-x: auto;
    padding: var(--space-lg);
    padding-bottom: var(--space-2xl);
    display: flex;
    flex-direction: column;
}

/* Empty Dashed Zone Placeholder */
.component-row-placeholder.dashed {
    border: 1.5px dashed var(--border-medium);
    border-radius: var(--radius-2xl);
    height: 40px;
    margin: var(--space-lg) var(--space-2xl);
    transition: var(--transition-normal);
}

.component-row-placeholder.dashed.drag-over {
    background: var(--surface-subtle-hover);
    border-color: var(--border-strong);
}

.placeholder-text {
    display: none; /* Removed text as per design */
}

/* Shared Grid Columns Template */
.glass-table-head,
.inner-table-head,
.component-row,
.subproduct-header-row {
    display: grid;
    /* Grip | Checkbox | Name | Price | Amount | Currency | Unit | Source | Dest | Actions */
    grid-template-columns: 20px 30px minmax(280px, 2.5fr) 90px 70px 100px 80px 100px 100px 40px;
    gap: 0.75rem;
    align-items: center;
}

.glass-table-head,
.inner-table-head {
    padding: 0.25rem 0.5rem;
    margin-bottom: 0.5rem;
    margin-top: 1rem;
}

.glass-table-head div,
.inner-table-head div {
    font-size: var(--font-size-sm);
    color: var(--color-text-faint);
    text-transform: capitalize;
    font-weight: 500;
    margin-left: var(--space-sm);
}

.component-row {
    padding: var(--space-xs) var(--space-sm);
    transition: var(--transition-fast);
}

/* Grip handle for drag-to-reorder */
.col-grip {
    display: flex;
    align-items: center;
    justify-content: center;
}

.grip-handle {
    color: rgba(255, 255, 255, 0.25);
    cursor: grab;
    transition: color 0.2s;
}

.grip-handle:hover {
    color: rgba(255, 255, 255, 0.6);
}

.component-row:active .grip-handle {
    cursor: grabbing;
}

/* Drag-to-reorder visual feedback */
.component-row.dragging {
    opacity: 0.4;
}

.component-row.drop-target {
    border-top: 2px solid var(--color-accent-cyan, #0ae6d3);
}

/* Price display (computed: base * amount) */
.price-display {
    font-size: var(--font-size-md);
    color: var(--color-text-primary);
    white-space: nowrap;
}

/* Sub-Product Card Container */
.subproduct-card {
    border: 1px solid rgba(255, 255, 255, 0.2);
    border-radius: var(--radius-3xl);
    margin-bottom: var(--space-xl);
    padding: 0;
    display: flex;
    flex-direction: column;
}

.sub-product-view-mode {
    padding: 0.75rem 1rem;
    background: rgba(255, 255, 255, 0.03);
    border-radius: var(--radius-lg);
    margin-bottom: 0;
}

.sub-product-top-row {
    display: flex;
    align-items: center;
    gap: var(--space-lg);
    padding-bottom: var(--space-lg);
    margin-bottom: var(--space-sm);
}

.product-image-placeholder--small {
    width: 60px;
    height: 60px;
}

.sub-product-image-inner {
    width: 100%;
    height: 100%;
    background: linear-gradient(135deg, #1e293b, #0f172a);
    display: flex;
    align-items: center;
    justify-content: center;
    border-radius: var(--radius-md);
}

.sub-product-controls {
    display: flex;
    gap: 0.75rem;
    align-items: center;
}

.subproduct-actions.vertical {
    display: flex;
    flex-direction: column;
    gap: 4px;
    justify-content: center;
}

.action-btn-circle {
    width: 28px;
    height: 28px;
    border-radius: 50%;
    display: flex;
    align-items: center;
    justify-content: center;
    background: rgba(255, 255, 255, 0.05);
    border: 1px solid var(--border-default);
    color: var(--color-text-dim);
    cursor: pointer;
}

.action-btn-circle--red {
    background: rgba(220, 38, 38, 0.15);
    border-color: var(--border-error-subtle);
    color: var(--color-negative-vivid);
}

.empty-subproduct-message {
    text-align: center;
    padding: var(--space-lg);
    color: var(--color-text-dim);
    font-weight: normal;
}

.col-actions {
    display: flex;
    justify-content: center;
}

.form-group--w-60 {
    width: 60px;
}

.form-group--w-80 {
    width: 80px;
}

.subproduct-header-row {
    padding-bottom: var(--space-lg);
    border-bottom: 1px solid var(--border-default);
    margin-bottom: var(--space-sm);
}

.subproduct-image-container {
    width: 60px;
    height: 60px;
    grid-column: 1 / 3; /* Spans checkbox and name col to align */
    display: flex;
    align-items: center;
    gap: 1rem;
}

/* Checkbox (Circle outline to Glow Check) */
.glass-checkbox {
    width: 24px;
    height: 24px;
    border: 2px solid var(--border-glass);
    border-radius: var(--radius-circle);
    background: transparent;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    transition: var(--transition-fast);
}
.glass-checkbox.checked {
    background: rgba(255, 255, 255, 0.2);
    border-color: rgba(255, 255, 255, 0.9);
    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);
}

/* Action Buttons Refinement (Pills instead of circles) */
.btn-action-pill {
    width: 32px;
    height: 32px;
    border-radius: var(--radius-circle);
    display: flex;
    align-items: center;
    justify-content: center;
    background: transparent;
    border: 1px solid var(--border-strong);
    color: rgba(255, 255, 255, 0.7);
    cursor: pointer;
    transition: var(--transition-fast);
}

.btn-action-pill:hover {
    background: var(--border-default);
    color: var(--color-text-primary);
}

/* Dark Red styling for inner trash */
.btn-action-pill.red {
    background: rgba(220, 38, 38, 0.15);
    border-color: var(--border-error-subtle);
    color: var(--color-negative-vivid);
}

.btn-action-pill--group {
    width: 48px;
    height: 28px;
    border-radius: var(--radius-md);
}

.btn-action-pill.red:hover {
    background: rgba(220, 38, 38, 0.3);
    color: var(--color-text-primary);
}

.model-builder-table-empty {
    background: transparent;
    border-radius: 20px;
    padding: var(--space-xl);
    text-align: center;
    color: var(--color-text-faint);
    border: 1px dashed var(--border-default);
    transition: var(--transition-fast);
}

/* Inner Table Reset */
.inner-table-body {
    padding: 0;
    max-height: none; /* Let the container handle scroll */
}

/* Custom Scrollbar for All Scrollable Areas (Sub-Products, Main Table, Search Panel) */
.inner-table-body::-webkit-scrollbar,
.panel-items::-webkit-scrollbar,
.model-builder-table-container::-webkit-scrollbar {
    width: 6px;
    height: 6px;
    /* For horizontal scroll if needed */
    background: transparent;
}

.inner-table-body::-webkit-scrollbar-track,
.panel-items::-webkit-scrollbar-track,
.model-builder-table-container::-webkit-scrollbar-track {
    background: transparent;
}

.inner-table-body::-webkit-scrollbar-thumb,
.panel-items::-webkit-scrollbar-thumb,
.model-builder-table-container::-webkit-scrollbar-thumb {
    background: rgba(255, 255, 255, 0.15);
    border-radius: 3px;
}

.inner-table-body::-webkit-scrollbar-thumb:hover,
.panel-items::-webkit-scrollbar-thumb:hover,
.model-builder-table-container::-webkit-scrollbar-thumb:hover {
    background: rgba(255, 255, 255, 0.3);
}

/* Base Glass Input/Select for Table */
.glass-box-input {
    background: var(--surface-input);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-md);
    padding: 0.35rem var(--space-sm);
    color: var(--color-text-primary);
    font-size: var(--font-size-base);
    outline: none;
    width: 100%;
    transition: var(--transition-fast);
}

.glass-box-input:focus {
    border-color: rgba(255, 255, 255, 0.25);
    background: var(--surface-input-focus);
}

.glass-box-select {
    background: var(--surface-input);
    border: 1px solid var(--border-default);
    border-radius: var(--radius-md);
    padding: 0.4rem 0.6rem;
    color: var(--color-text-primary);
    font-size: var(--font-size-base);
    outline: none;
    cursor: pointer;
    width: 100%;
}

.glass-box-select option {
    background-color: var(--surface-dark-gradient-start);
    color: var(--color-text-primary);
    padding: var(--space-sm);
}

/* ============================================
   BOTTOM ACTIONS (Inside Border Wrapper)
   ============================================ */
.model-builder-actions {
    display: flex;
    justify-content: flex-end;
    gap: var(--space-xl);
    margin-top: auto;
    padding: var(--space-lg);
}

.btn-glass-cancel {
    padding: 0.6rem var(--space-2xl);
    background: rgba(185, 28, 28, 0.15);
    border: 1px solid var(--border-error-subtle);
    border-radius: var(--radius-lg);
    color: var(--color-text-primary);
    font-size: var(--font-size-md);
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition-fast);
    text-transform: uppercase;
}

.btn-glass-cancel:hover {
    background: rgba(185, 28, 28, 0.3);
    border-color: rgba(220, 38, 38, 0.5);
}

.btn-glass-save {
    padding: 0.6rem 2.5rem;
    background: rgba(76, 29, 149, 0.3);
    border: 1px solid var(--border-primary);
    border-radius: var(--radius-lg);
    color: var(--color-text-primary);
    font-size: var(--font-size-md);
    font-weight: 600;
    cursor: pointer;
    transition: var(--transition-fast);
    text-transform: uppercase;
}

.btn-glass-save:hover {
    background: rgba(76, 29, 149, 0.5);
    border-color: var(--border-primary-hover);
}

/* Base Pill Dropzone */
.dropzone-pill {
    flex: 1 1;
    border: 1.5px dashed var(--border-medium);
    border-radius: var(--radius-2xl);
    height: 48px;
    display: flex;
    align-items: center;
    justify-content: center;
    margin-top: var(--space-lg);
}

/* ============================================
   RESPONSIVE
   ============================================ */
@media (max-width: 1200px) {
    .model-builder-container {
        flex-direction: column;
        height: 95vh;
    }

    .component-search-panel {
        width: 100%;
        min-width: auto;
        max-height: 250px;
    }

    .panel-items {
        flex-direction: row;
        flex-wrap: wrap;
    }

    .panel-item {
        flex-grow: 0;
        flex-shrink: 0;
        flex-basis: calc(33.33% - 0.5rem);
    }
}

.glass-pill-input:disabled, .glass-pill-select:disabled { opacity: 0.5; cursor: not-allowed; pointer-events: none; }



`, "",{"version":3,"sources":["webpack://./src/css/model-builder.css"],"names":[],"mappings":"AAAA;;iDAEiD;;AAEjD,sBAAsB;AACtB;IACI,eAAe;IACf,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,aAAa;IACb,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA,8BAA8B;AAC9B;IACI,kBAAkB;IAClB,MAAM;IACN,OAAO;IACP,QAAQ;IACR,SAAS;IACT,8BAA8B;IAC9B,gCAAgC;IAChC,0BAA0B;AAC9B;;AAEA,mBAAmB;AACnB;IACI,kBAAkB;IAClB,aAAa;IACb,SAAS;IACT,UAAU;IACV,iBAAiB;IACjB,cAAc;IACd,YAAY;IACZ,2BAA2B;IAC3B,iBAAiB;IACjB,UAAU;AACd;;AAEA,+BAA+B;AAC/B;IACI,gCAAgC;IAChC,0BAA0B;IAC1B,kCAAkC;IAClC,uCAAuC;IACvC;;+CAE2C;AAC/C;;AAEA;;iDAEiD;AACjD;IACI,YAAY;IACZ,gBAAgB;IAChB,uBAAuB;IACvB,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,wBAAwB;IACxB,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,yCAAyC;AAC7C;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,qBAAqB;IACrB,qBAAqB;IACrB,yBAAyB;AAC7B;;AAEA,uBAAuB;AACvB;IACI,aAAa;IACb,gCAAgC;IAChC,iCAAiC;IACjC,YAAY;IACZ,sBAAsB;IACtB,sCAAsC;AAC1C;;AAEA;IACI,SAAO;IACP,wCAAwC;IACxC,uBAAuB;IACvB,YAAY;IACZ,4BAA4B;IAC5B,gCAAgC;IAChC,gBAAgB;IAChB,eAAe;IACf,oCAAoC;IACpC,mBAAmB;AACvB;;AAEA;IACI,iCAAiC;IACjC,2BAA2B;IAC3B,gCAAgC;IAChC,uCAAuC;IACvC,yCAAyC;AAC7C;;AAEA;IACI,kCAAkC;IAClC,iCAAiC;AACrC;;AAEA,WAAW;AACX;IACI,kBAAkB;IAClB,sBAAsB;AAC1B;;AAEA;IACI,kBAAkB;IAClB,UAAU;IACV,QAAQ;IACR,2BAA2B;IAC3B,8BAA8B;IAC9B,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,gDAAgD;IAChD,gCAAgC;IAChC,sCAAsC;IACtC,iCAAiC;IACjC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,kCAAkC;AACtC;;AAEA;IACI,qCAAqC;IACrC,iCAAiC;AACrC;;AAEA,eAAe;AACf;IACI,SAAO;IACP,gBAAgB;IAChB,aAAa;IACb,sBAAsB;IACtB,WAAW;IACX,kBAAkB;AACtB;;AAEA,kDAAkD;AAClD;IACI,wBAAwB;IACxB,+BAA+B;IAC/B,sCAAsC;IACtC,gCAAgC;IAChC,eAAe;IACf,kCAAkC;IAClC,aAAa;IACb,mBAAmB;IACnB,oBAAoB;AACxB;;AAEA;IACI,qCAAqC;IACrC,mCAAmC;IACnC,yCAAyC;AAC7C;;AAEA,yCAAyC;AACzC;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;IAC/B,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,iBAAiB;AACrB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,SAAO;IACP,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,aAAa;IACb,8BAA8B;IAC9B,mBAAmB;IACnB,WAAW;AACf;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;IAChC,gBAAgB;IAChB,SAAO;IACP,YAAY;IACZ,sBAAsB;IACtB,8BAA8B;AAClC;;AAEA;IACI,kBAAkB;IAClB,aAAa;IACb,sBAAsB;IACtB,uBAAuB;IACvB,mBAAmB;IACnB,+CAA+C;IAC/C,6BAA6B;IAC7B,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,gCAAgC;IAChC,gBAAgB;IAChB,gCAAgC;AACpC;;AAEA;IACI,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,8BAA8B;IAC9B,kBAAkB;IAClB,wBAAwB;AAC5B;;AAEA;IACI,WAAW;IACX,gBAAgB;IAChB,2BAA2B;IAC3B,oCAAoC;IACpC,0CAA0C;IAC1C,kBAAkB;IAClB,8BAA8B;IAC9B,eAAe;IACf,8BAA8B;AAClC;;AAEA;IACI,oBAAoB;IACpB,mBAAmB;IACnB,WAAW;IACX,8BAA8B;IAC9B,8BAA8B;IAC9B,eAAe;IACf,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;;iDAEiD;AACjD;IACI,SAAO;IACP,uBAAuB;IACvB,2BAA2B;IAC3B,mCAAmC;IACnC,gCAAgC;IAChC,aAAa;IACb,sBAAsB;IACtB,qCAAqC;IACrC,yCAAyC;IACzC,kBAAkB;AACtB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,8BAA8B;IAC9B,8BAA8B;AAClC;;AAEA;IACI,iBAAiB;IACjB,gBAAgB;IAChB,gCAAgC;IAChC,SAAS;IACT,mBAAmB;IACnB,yBAAyB;AAC7B;;AAEA,0CAA0C;AAC1C;;IAEI,gCAAgC;IAChC,sCAAsC;IACtC,gCAAgC;IAChC,wCAAwC;IACxC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,kCAAkC;IAClC,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;;IAEI,iCAAiC;IACjC,sCAAsC;AAC1C;;AAEA;IACI,eAAe;IACf,yDAAof;IACpf,4BAA4B;IAC5B,yCAAyC;IACzC,6BAA6B;IAC7B,mBAAmB;AACvB;;AAEA;IACI,oDAAoD;IACpD,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA,+BAA+B;AAC/B;IACI,kBAAkB;IAClB,aAAa;IACb,mBAAmB;AACvB;;AAEA;IACI,kBAAkB;IAClB,qBAAqB;IACrB,WAAW;IACX,YAAY;IACZ,sCAAsC;IACtC,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gCAAgC;IAChC,8BAA8B;IAC9B,iBAAiB;IACjB,UAAU;IACV,oBAAoB;AACxB;;AAEA;IACI,kBAAkB,EAAE,8BAA8B;AACtD;;AAEA,WAAW;AACX;IACI,aAAa;IACb,sBAAsB;IACtB,WAAW;AACf;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,8BAA8B;IAC9B,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,iBAAiB;IACjB,8BAA8B;IAC9B,gBAAgB;IAChB,0BAA0B;IAC1B,4BAA4B;AAChC;;AAEA;IACI,cAAc;IACd,kBAAkB;IAClB,cAAc;IACd,kBAAkB;IAClB,8BAA8B;IAC9B,yBAAyB;AAC7B;;AAEA,4CAA4C;AAC5C;IACI,aAAa;IACb,sBAAsB;IACtB,MAAM;IACN,+BAA+B;IAC/B,8CAA8C;IAC9C,4BAA4B;IAC5B,iCAAiC;IACjC,yBAAyB;AAC7B;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,qBAAqB;IACrB,WAAW;AACf;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,cAAc;AAClB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,+BAA+B;IAC/B,uCAAuC;IACvC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,gBAAgB;AACpB;;AAEA;IACI,eAAe;IACf,kBAAkB;AACtB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,iBAAiB;IACjB,sBAAsB;AAC1B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,aAAa;IACb,sBAAsB;IACtB,mBAAmB;IACnB,uBAAuB;IACvB,QAAQ;AACZ;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;IACpB,SAAO;AACX;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,oBAAoB;AACxB;;AAEA;IACI,SAAO;AACX;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,YAAY;AAChB;;AAEA;IACI,mBAAmB;IACnB,kBAAkB;AACtB;;AAEA;IACI,8BAA8B;IAC9B,gBAAgB;IAChB,8BAA8B;IAC9B,yBAAyB;IACzB,qBAAqB;AACzB;;AAEA;IACI,gCAAgC;IAChC,wCAAwC;IACxC,+BAA+B;IAC/B,wCAAwC;IACxC,gCAAgC;IAChC,8BAA8B;IAC9B,aAAa;IACb,kCAAkC;IAClC,WAAW;AACf;;AAEA;IACI,eAAe;IACf,wBAAwB;IACxB,uBAAuB;IACvB,YAAY;IACZ,gCAAgC;IAChC,WAAW;AACf;;AAEA;IACI,sCAAsC;IACtC,sCAAsC;AAC1C;;AAEA;IACI,aAAa;IACb,oBAAoB;IACpB,qBAAqB;AACzB;;AAEA;;iDAEiD;AACjD;IACI,SAAO;IACP,gBAAgB;IAChB,gBAAgB;IAChB,wBAAwB;IACxB,gCAAgC;IAChC,aAAa;IACb,sBAAsB;AAC1B;;AAEA,kCAAkC;AAClC;IACI,yCAAyC;IACzC,gCAAgC;IAChC,YAAY;IACZ,wCAAwC;IACxC,oCAAoC;AACxC;;AAEA;IACI,uCAAuC;IACvC,kCAAkC;AACtC;;AAEA;IACI,aAAa,EAAE,+BAA+B;AAClD;;AAEA,iCAAiC;AACjC;;;;IAII,aAAa;IACb,wFAAwF;IACxF,2FAA2F;IAC3F,YAAY;IACZ,mBAAmB;AACvB;;AAEA;;IAEI,uBAAuB;IACvB,qBAAqB;IACrB,gBAAgB;AACpB;;AAEA;;IAEI,8BAA8B;IAC9B,8BAA8B;IAC9B,0BAA0B;IAC1B,gBAAgB;IAChB,4BAA4B;AAChC;;AAEA;IACI,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA,oCAAoC;AACpC;IACI,aAAa;IACb,mBAAmB;IACnB,uBAAuB;AAC3B;;AAEA;IACI,gCAAgC;IAChC,YAAY;IACZ,sBAAsB;AAC1B;;AAEA;IACI,+BAA+B;AACnC;;AAEA;IACI,gBAAgB;AACpB;;AAEA,oCAAoC;AACpC;IACI,YAAY;AAChB;;AAEA;IACI,uDAAuD;AAC3D;;AAEA,4CAA4C;AAC5C;IACI,8BAA8B;IAC9B,gCAAgC;IAChC,mBAAmB;AACvB;;AAEA,+BAA+B;AAC/B;IACI,0CAA0C;IAC1C,gCAAgC;IAChC,8BAA8B;IAC9B,UAAU;IACV,aAAa;IACb,sBAAsB;AAC1B;;AAEA;IACI,qBAAqB;IACrB,qCAAqC;IACrC,+BAA+B;IAC/B,gBAAgB;AACpB;;AAEA;IACI,aAAa;IACb,mBAAmB;IACnB,oBAAoB;IACpB,+BAA+B;IAC/B,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;AAChB;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,qDAAqD;IACrD,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,+BAA+B;AACnC;;AAEA;IACI,aAAa;IACb,YAAY;IACZ,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,sBAAsB;IACtB,QAAQ;IACR,uBAAuB;AAC3B;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB;IAClB,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,qCAAqC;IACrC,uCAAuC;IACvC,4BAA4B;IAC5B,eAAe;AACnB;;AAEA;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA;IACI,kBAAkB;IAClB,wBAAwB;IACxB,4BAA4B;IAC5B,mBAAmB;AACvB;;AAEA;IACI,aAAa;IACb,uBAAuB;AAC3B;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,WAAW;AACf;;AAEA;IACI,+BAA+B;IAC/B,8CAA8C;IAC9C,8BAA8B;AAClC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,kBAAkB,EAAE,yCAAyC;IAC7D,aAAa;IACb,mBAAmB;IACnB,SAAS;AACb;;AAEA,4CAA4C;AAC5C;IACI,WAAW;IACX,YAAY;IACZ,qCAAqC;IACrC,mCAAmC;IACnC,uBAAuB;IACvB,eAAe;IACf,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,kCAAkC;AACtC;AACA;IACI,oCAAoC;IACpC,sCAAsC;IACtC,6CAA6C;AACjD;;AAEA,yDAAyD;AACzD;IACI,WAAW;IACX,YAAY;IACZ,mCAAmC;IACnC,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,uBAAuB;IACvB,sCAAsC;IACtC,+BAA+B;IAC/B,eAAe;IACf,kCAAkC;AACtC;;AAEA;IACI,iCAAiC;IACjC,gCAAgC;AACpC;;AAEA,qCAAqC;AACrC;IACI,mCAAmC;IACnC,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA;IACI,WAAW;IACX,YAAY;IACZ,+BAA+B;AACnC;;AAEA;IACI,kCAAkC;IAClC,gCAAgC;AACpC;;AAEA;IACI,uBAAuB;IACvB,mBAAmB;IACnB,wBAAwB;IACxB,kBAAkB;IAClB,8BAA8B;IAC9B,wCAAwC;IACxC,kCAAkC;AACtC;;AAEA,sBAAsB;AACtB;IACI,UAAU;IACV,gBAAgB,EAAE,oCAAoC;AAC1D;;AAEA,uFAAuF;AACvF;;;IAGI,UAAU;IACV,WAAW;IACX,oCAAoC;IACpC,uBAAuB;AAC3B;;AAEA;;;IAGI,uBAAuB;AAC3B;;AAEA;;;IAGI,qCAAqC;IACrC,kBAAkB;AACtB;;AAEA;;;IAGI,oCAAoC;AACxC;;AAEA,sCAAsC;AACtC;IACI,gCAAgC;IAChC,uCAAuC;IACvC,+BAA+B;IAC/B,gCAAgC;IAChC,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,WAAW;IACX,kCAAkC;AACtC;;AAEA;IACI,uCAAuC;IACvC,sCAAsC;AAC1C;;AAEA;IACI,gCAAgC;IAChC,uCAAuC;IACvC,+BAA+B;IAC/B,sBAAsB;IACtB,gCAAgC;IAChC,gCAAgC;IAChC,aAAa;IACb,eAAe;IACf,WAAW;AACf;;AAEA;IACI,oDAAoD;IACpD,gCAAgC;IAChC,wBAAwB;AAC5B;;AAEA;;iDAEiD;AACjD;IACI,aAAa;IACb,yBAAyB;IACzB,oBAAoB;IACpB,gBAAgB;IAChB,wBAAwB;AAC5B;;AAEA;IACI,gCAAgC;IAChC,mCAAmC;IACnC,4CAA4C;IAC5C,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,oCAAoC;AACxC;;AAEA;IACI,sBAAsB;IACtB,kCAAkC;IAClC,uCAAuC;IACvC,+BAA+B;IAC/B,gCAAgC;IAChC,8BAA8B;IAC9B,gBAAgB;IAChB,eAAe;IACf,kCAAkC;IAClC,yBAAyB;AAC7B;;AAEA;IACI,kCAAkC;IAClC,yCAAyC;AAC7C;;AAEA,uBAAuB;AACvB;IACI,SAAO;IACP,yCAAyC;IACzC,gCAAgC;IAChC,YAAY;IACZ,aAAa;IACb,mBAAmB;IACnB,uBAAuB;IACvB,2BAA2B;AAC/B;;AAEA;;iDAEiD;AACjD;IACI;QACI,sBAAsB;QACtB,YAAY;IAChB;;IAEA;QACI,WAAW;QACX,eAAe;QACf,iBAAiB;IACrB;;IAEA;QACI,mBAAmB;QACnB,eAAe;IACnB;;IAEA;QACI,YAA+B;QAA/B,cAA+B;QAA/B,iCAA+B;IACnC;AACJ;;AAEA,0DAA0D,YAAY,EAAE,mBAAmB,EAAE,oBAAoB,EAAE","sourcesContent":["/* ============================================\n   MODEL BUILDER OVERLAY STYLES\n   ============================================ */\n\n/* Overlay Container */\n.model-builder-overlay {\n    position: fixed;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    z-index: 1000;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n/* Semi-transparent backdrop */\n.model-builder-backdrop {\n    position: absolute;\n    top: 0;\n    left: 0;\n    right: 0;\n    bottom: 0;\n    background: rgba(0, 0, 0, 0.4);\n    /* Lighter backdrop per design */\n    backdrop-filter: blur(1px);\n}\n\n/* Main container */\n.model-builder-container {\n    position: relative;\n    display: flex;\n    gap: 2rem;\n    width: 90%;\n    max-width: 1500px;\n    margin: 0 auto;\n    height: 90vh;\n    /* Taller for better view */\n    max-height: 900px;\n    z-index: 1;\n}\n\n/* Glassmorphism Base Utility */\n.glass-ui-box {\n    background: var(--surface-glass);\n    backdrop-filter: blur(4px);\n    -webkit-backdrop-filter: blur(5px);\n    border: 1px solid var(--border-default);\n    box-shadow: -2px 0 2px rgba(255, 255, 255, 0.1),\n        2px 0 2px rgba(255, 255, 255, 0.1),\n        inset 0 1px 0 rgba(255, 255, 255, 0.05);\n}\n\n/* ============================================\n   LEFT PANEL - COMPONENT SEARCH\n   ============================================ */\n.component-search-panel {\n    width: 400px;\n    min-width: 400px;\n    background: transparent;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border-radius: var(--radius-3xl);\n    padding: var(--space-xl);\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-glass);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n}\n\n.panel-title {\n    font-size: var(--font-size-base);\n    font-weight: 700;\n    color: var(--color-text-primary);\n    margin: 0 0 1.25rem 0;\n    letter-spacing: 0.5px;\n    text-transform: uppercase;\n}\n\n/* Pill Tabs Selector */\n.panel-tabs {\n    display: flex;\n    background: var(--surface-input);\n    border-radius: var(--radius-pill);\n    padding: 3px;\n    margin-bottom: 1.25rem;\n    border: 1px solid var(--border-strong);\n}\n\n.panel-tab {\n    flex: 1;\n    padding: var(--space-sm) var(--space-lg);\n    background: transparent;\n    border: none;\n    color: var(--color-text-dim);\n    font-size: var(--font-size-base);\n    font-weight: 500;\n    cursor: pointer;\n    transition: var(--transition-normal);\n    border-radius: 30px;\n}\n\n.panel-tab.active {\n    background: var(--border-default);\n    backdrop-filter: blur(10px);\n    color: var(--color-text-primary);\n    border: 1px solid var(--border-default);\n    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);\n}\n\n.panel-tab:not(.active):hover {\n    color: var(--color-text-secondary);\n    background: var(--surface-subtle);\n}\n\n/* Search */\n.panel-search {\n    position: relative;\n    margin-bottom: 1.25rem;\n}\n\n.panel-search .search-icon {\n    position: absolute;\n    left: 12px;\n    top: 50%;\n    transform: translateY(-50%);\n    color: var(--color-text-faint);\n    width: 14px;\n    height: 14px;\n}\n\n.panel-search .search-input {\n    width: 100%;\n    padding: 0.55rem var(--space-lg) 0.55rem 2.25rem;\n    background: var(--surface-input);\n    border: 1px solid var(--border-medium);\n    border-radius: var(--radius-pill);\n    color: var(--color-text-primary);\n    font-size: var(--font-size-base);\n    outline: none;\n    transition: var(--transition-fast);\n}\n\n.panel-search .search-input:focus {\n    border-color: rgba(139, 92, 246, 0.5);\n    background: rgba(51, 51, 51, 0.4);\n}\n\n/* Items List */\n.panel-items {\n    flex: 1;\n    overflow-y: auto;\n    display: flex;\n    flex-direction: column;\n    gap: 0.6rem;\n    padding-right: 4px;\n}\n\n/* Glass card row — matches Figma overlay design */\n.panel-item {\n    padding: 0.85rem 1.25rem;\n    background: rgba(0, 0, 0, 0.15);\n    border: 1px solid var(--border-strong);\n    border-radius: var(--radius-2xl);\n    cursor: pointer;\n    transition: var(--transition-fast);\n    display: flex;\n    align-items: center;\n    gap: var(--space-sm);\n}\n\n.panel-item:hover {\n    background: rgba(255, 255, 255, 0.08);\n    border-color: var(--color-text-dim);\n    box-shadow: 0 4px 12px rgba(0, 0, 0, 0.2);\n}\n\n/* Product items with image placeholder */\n.item-visual {\n    width: 40px;\n    height: 40px;\n    border-radius: var(--radius-md);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    flex-shrink: 0;\n}\n\n.item-visual__image {\n    width: 36px;\n    height: 36px;\n    border-radius: 6px;\n    object-fit: cover;\n}\n\n.item-visual__placeholder {\n    width: 36px;\n    height: 36px;\n    border-radius: 6px;\n    background: rgba(139, 92, 246, 0.2);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.item-info {\n    flex: 1;\n    display: flex;\n    flex-direction: column;\n}\n\n.item-header {\n    display: flex;\n    justify-content: space-between;\n    align-items: center;\n    width: 100%;\n}\n\n.item-name {\n    font-size: var(--font-size-base);\n    font-weight: 600;\n    color: var(--color-text-primary);\n    line-height: 1.3;\n    flex: 1;\n    min-width: 0;\n    word-break: break-word;\n    padding-right: var(--space-lg);\n}\n\n.item-price-stack {\n    text-align: center;\n    display: flex;\n    flex-direction: column;\n    justify-content: center;\n    align-items: center;\n    border-left: 1px solid rgba(255, 255, 255, 0.2);\n    padding-left: var(--space-lg);\n    width: 110px;\n    flex-shrink: 0;\n}\n\n.item-price {\n    font-size: var(--font-size-base);\n    font-weight: 600;\n    color: var(--color-text-primary);\n}\n\n.item-unit {\n    font-size: 11px;\n    color: var(--color-text-faint);\n}\n\n.empty-search {\n    color: var(--color-text-faint);\n    text-align: center;\n    padding: var(--space-lg);\n}\n\n.load-more-btn {\n    width: 100%;\n    padding: 0.75rem;\n    margin-top: var(--space-sm);\n    background: rgba(255, 255, 255, 0.1);\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: 6px;\n    color: var(--color-text-muted);\n    cursor: pointer;\n    font-size: var(--font-size-md);\n}\n\n.item-type-indicator {\n    display: inline-flex;\n    align-items: center;\n    gap: 0.3rem;\n    font-size: var(--font-size-xs);\n    color: var(--color-text-faint);\n    margin-top: 4px;\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n/* ============================================\n   RIGHT PANEL - MODEL BUILDER (GLASS BORDER WRAPPER)\n   ============================================ */\n.model-builder-main {\n    flex: 1;\n    background: transparent;\n    backdrop-filter: blur(10px);\n    -webkit-backdrop-filter: blur(10px);\n    border-radius: var(--radius-3xl);\n    display: flex;\n    flex-direction: column;\n    border: 1px solid var(--border-glass);\n    box-shadow: 0 4px 30px rgba(0, 0, 0, 0.1);\n    position: relative;\n}\n\n.model-builder-header {\n    display: flex;\n    align-items: center;\n    justify-content: space-between;\n    margin-bottom: var(--space-xl);\n}\n\n.model-builder-title {\n    font-size: 1.2rem;\n    font-weight: 800;\n    color: var(--color-text-primary);\n    margin: 0;\n    letter-spacing: 1px;\n    text-transform: uppercase;\n}\n\n/* Base Pill Inputs (Text/Number/Select) */\n.glass-pill-input,\n.glass-pill-select {\n    background: var(--surface-input);\n    border: 1px solid var(--border-medium);\n    border-radius: var(--radius-2xl);\n    padding: var(--space-sm) var(--space-lg);\n    color: var(--color-text-primary);\n    font-size: var(--font-size-base);\n    outline: none;\n    width: 100%;\n    transition: var(--transition-fast);\n    appearance: none;\n    -webkit-appearance: none;\n}\n\n.glass-pill-input:focus,\n.glass-pill-select:focus {\n    border-color: var(--border-glass);\n    background: var(--surface-input-focus);\n}\n\n.glass-pill-select {\n    cursor: pointer;\n    background-image: url(\"data:image/svg+xml;charset=US-ASCII,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20width%3D%22292.4%22%20height%3D%22292.4%22%3E%3Cpath%20fill%3D%22%23FFFFFF%22%20d%3D%22M287%2069.4a17.6%2017.6%200%200%200-13-5.4H18.4c-5%200-9.3%201.8-12.9%205.4A17.6%2017.6%200%200%200%200%2082.2c0%205%201.8%209.3%205.4%2012.9l128%20127.9c3.6%203.6%207.8%205.4%2012.8%205.4s9.2-1.8%2012.8-5.4L287%2095c3.5-3.5%205.4-7.8%205.4-12.8%200-5-1.9-9.2-5.5-12.8z%22%2F%3E%3C%2Fsvg%3E\");\n    background-repeat: no-repeat;\n    background-position: right 0.7rem top 50%;\n    background-size: 0.65rem auto;\n    padding-right: 2rem;\n}\n\n.glass-pill-select option {\n    background-color: var(--surface-dark-gradient-start);\n    color: var(--color-text-primary);\n    padding: var(--space-sm);\n}\n\n/* Currency Wrapper with Icon */\n.currency-pill-wrapper {\n    position: relative;\n    display: flex;\n    align-items: center;\n}\n\n.currency-icon-dot {\n    position: absolute;\n    left: var(--space-sm);\n    width: 16px;\n    height: 16px;\n    background: var(--color-accent-yellow);\n    border-radius: var(--radius-circle);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    color: var(--color-text-primary);\n    font-size: var(--font-size-xs);\n    font-weight: bold;\n    z-index: 1;\n    pointer-events: none;\n}\n\n.currency-pill-wrapper .glass-pill-select {\n    padding-left: 2rem; /* Make room for yellow icon */\n}\n\n/* Labels */\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: 0.4rem;\n}\n\n.form-label {\n    font-size: var(--font-size-sm);\n    font-weight: 500;\n    color: var(--color-text-faint);\n    text-transform: capitalize;\n    margin-left: var(--space-sm);\n}\n\n.form-label-mini {\n    font-size: 0.7rem;\n    color: var(--color-text-muted);\n    font-weight: 500;\n    text-transform: capitalize;\n    margin-left: var(--space-sm);\n}\n\n.form-label-mini--sub {\n    display: block;\n    margin-bottom: 4px;\n    margin-left: 0;\n    font-size: 0.65rem;\n    color: var(--color-text-faint);\n    text-transform: uppercase;\n}\n\n/* Main Product Card Styling (Header Area) */\n.model-builder-product-row {\n    display: flex;\n    flex-direction: column;\n    gap: 0;\n    margin-bottom: var(--space-2xl);\n    border-bottom: solid 1px var(--border-default);\n    border-radius: 0 0 14px 14px;\n    background: var(--surface-subtle);\n    padding: var(--space-2xl);\n}\n\n.product-top-row {\n    display: flex;\n    gap: var(--space-xl);\n    align-items: flex-end;\n    width: 100%;\n}\n\n.product-image-container {\n    width: 80px;\n    height: 80px;\n    flex-shrink: 0;\n}\n\n.product-image-placeholder {\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.07);\n    border-radius: var(--radius-lg);\n    border: 1px solid var(--border-default);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    overflow: hidden;\n}\n\n.product-image-placeholder--clickable {\n    cursor: pointer;\n    position: relative;\n}\n\n.product-image-preview {\n    width: 100%;\n    height: 100%;\n    object-fit: cover;\n    border-radius: inherit;\n}\n\n.product-image-upload-hint {\n    width: 100%;\n    height: 100%;\n    background: rgba(255, 255, 255, 0.05);\n    display: flex;\n    flex-direction: column;\n    align-items: center;\n    justify-content: center;\n    gap: 4px;\n}\n\n.product-name-section {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-lg);\n    flex: 1;\n}\n\n.form-group {\n    display: flex;\n    flex-direction: column;\n    gap: var(--space-sm);\n}\n\n.form-group--flex {\n    flex: 1;\n}\n\n.form-group--w-70 {\n    width: 70px;\n}\n\n.form-group--w-90 {\n    width: 90px;\n}\n\n.form-group--w-120 {\n    width: 120px;\n}\n\n.product-bottom-row {\n    margin-top: 0.75rem;\n    padding-left: 92px;\n}\n\n.form-label {\n    font-size: var(--font-size-sm);\n    font-weight: 600;\n    color: var(--color-text-faint);\n    text-transform: uppercase;\n    letter-spacing: 0.5px;\n}\n\n.glass-input-main {\n    background: var(--surface-input);\n    border: 1.5px solid var(--border-subtle);\n    border-radius: var(--radius-lg);\n    padding: var(--space-md) var(--space-lg);\n    color: var(--color-text-primary);\n    font-size: var(--font-size-xl);\n    outline: none;\n    transition: var(--transition-fast);\n    width: 100%;\n}\n\n.glass-input-main--inline {\n    font-size: 1rem;\n    padding: var(--space-sm);\n    background: transparent;\n    border: none;\n    color: var(--color-text-primary);\n    width: 100%;\n}\n\n.glass-input-main:focus {\n    border-color: rgba(255, 255, 255, 0.2);\n    background: var(--surface-input-focus);\n}\n\n.product-controls-grid {\n    display: flex;\n    gap: var(--space-lg);\n    align-items: flex-end;\n}\n\n/* ============================================\n   TABLE & SUB-PRODUCT CARDS\n   ============================================ */\n.model-builder-table-container {\n    flex: 1;\n    overflow-y: auto;\n    overflow-x: auto;\n    padding: var(--space-lg);\n    padding-bottom: var(--space-2xl);\n    display: flex;\n    flex-direction: column;\n}\n\n/* Empty Dashed Zone Placeholder */\n.component-row-placeholder.dashed {\n    border: 1.5px dashed var(--border-medium);\n    border-radius: var(--radius-2xl);\n    height: 40px;\n    margin: var(--space-lg) var(--space-2xl);\n    transition: var(--transition-normal);\n}\n\n.component-row-placeholder.dashed.drag-over {\n    background: var(--surface-subtle-hover);\n    border-color: var(--border-strong);\n}\n\n.placeholder-text {\n    display: none; /* Removed text as per design */\n}\n\n/* Shared Grid Columns Template */\n.glass-table-head,\n.inner-table-head,\n.component-row,\n.subproduct-header-row {\n    display: grid;\n    /* Grip | Checkbox | Name | Price | Amount | Currency | Unit | Source | Dest | Actions */\n    grid-template-columns: 20px 30px minmax(280px, 2.5fr) 90px 70px 100px 80px 100px 100px 40px;\n    gap: 0.75rem;\n    align-items: center;\n}\n\n.glass-table-head,\n.inner-table-head {\n    padding: 0.25rem 0.5rem;\n    margin-bottom: 0.5rem;\n    margin-top: 1rem;\n}\n\n.glass-table-head div,\n.inner-table-head div {\n    font-size: var(--font-size-sm);\n    color: var(--color-text-faint);\n    text-transform: capitalize;\n    font-weight: 500;\n    margin-left: var(--space-sm);\n}\n\n.component-row {\n    padding: var(--space-xs) var(--space-sm);\n    transition: var(--transition-fast);\n}\n\n/* Grip handle for drag-to-reorder */\n.col-grip {\n    display: flex;\n    align-items: center;\n    justify-content: center;\n}\n\n.grip-handle {\n    color: rgba(255, 255, 255, 0.25);\n    cursor: grab;\n    transition: color 0.2s;\n}\n\n.grip-handle:hover {\n    color: rgba(255, 255, 255, 0.6);\n}\n\n.component-row:active .grip-handle {\n    cursor: grabbing;\n}\n\n/* Drag-to-reorder visual feedback */\n.component-row.dragging {\n    opacity: 0.4;\n}\n\n.component-row.drop-target {\n    border-top: 2px solid var(--color-accent-cyan, #0ae6d3);\n}\n\n/* Price display (computed: base * amount) */\n.price-display {\n    font-size: var(--font-size-md);\n    color: var(--color-text-primary);\n    white-space: nowrap;\n}\n\n/* Sub-Product Card Container */\n.subproduct-card {\n    border: 1px solid rgba(255, 255, 255, 0.2);\n    border-radius: var(--radius-3xl);\n    margin-bottom: var(--space-xl);\n    padding: 0;\n    display: flex;\n    flex-direction: column;\n}\n\n.sub-product-view-mode {\n    padding: 0.75rem 1rem;\n    background: rgba(255, 255, 255, 0.03);\n    border-radius: var(--radius-lg);\n    margin-bottom: 0;\n}\n\n.sub-product-top-row {\n    display: flex;\n    align-items: center;\n    gap: var(--space-lg);\n    padding-bottom: var(--space-lg);\n    margin-bottom: var(--space-sm);\n}\n\n.product-image-placeholder--small {\n    width: 60px;\n    height: 60px;\n}\n\n.sub-product-image-inner {\n    width: 100%;\n    height: 100%;\n    background: linear-gradient(135deg, #1e293b, #0f172a);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    border-radius: var(--radius-md);\n}\n\n.sub-product-controls {\n    display: flex;\n    gap: 0.75rem;\n    align-items: center;\n}\n\n.subproduct-actions.vertical {\n    display: flex;\n    flex-direction: column;\n    gap: 4px;\n    justify-content: center;\n}\n\n.action-btn-circle {\n    width: 28px;\n    height: 28px;\n    border-radius: 50%;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: rgba(255, 255, 255, 0.05);\n    border: 1px solid var(--border-default);\n    color: var(--color-text-dim);\n    cursor: pointer;\n}\n\n.action-btn-circle--red {\n    background: rgba(220, 38, 38, 0.15);\n    border-color: var(--border-error-subtle);\n    color: var(--color-negative-vivid);\n}\n\n.empty-subproduct-message {\n    text-align: center;\n    padding: var(--space-lg);\n    color: var(--color-text-dim);\n    font-weight: normal;\n}\n\n.col-actions {\n    display: flex;\n    justify-content: center;\n}\n\n.form-group--w-60 {\n    width: 60px;\n}\n\n.form-group--w-80 {\n    width: 80px;\n}\n\n.subproduct-header-row {\n    padding-bottom: var(--space-lg);\n    border-bottom: 1px solid var(--border-default);\n    margin-bottom: var(--space-sm);\n}\n\n.subproduct-image-container {\n    width: 60px;\n    height: 60px;\n    grid-column: 1 / 3; /* Spans checkbox and name col to align */\n    display: flex;\n    align-items: center;\n    gap: 1rem;\n}\n\n/* Checkbox (Circle outline to Glow Check) */\n.glass-checkbox {\n    width: 24px;\n    height: 24px;\n    border: 2px solid var(--border-glass);\n    border-radius: var(--radius-circle);\n    background: transparent;\n    cursor: pointer;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    transition: var(--transition-fast);\n}\n.glass-checkbox.checked {\n    background: rgba(255, 255, 255, 0.2);\n    border-color: rgba(255, 255, 255, 0.9);\n    box-shadow: 0 0 10px rgba(255, 255, 255, 0.1);\n}\n\n/* Action Buttons Refinement (Pills instead of circles) */\n.btn-action-pill {\n    width: 32px;\n    height: 32px;\n    border-radius: var(--radius-circle);\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    background: transparent;\n    border: 1px solid var(--border-strong);\n    color: rgba(255, 255, 255, 0.7);\n    cursor: pointer;\n    transition: var(--transition-fast);\n}\n\n.btn-action-pill:hover {\n    background: var(--border-default);\n    color: var(--color-text-primary);\n}\n\n/* Dark Red styling for inner trash */\n.btn-action-pill.red {\n    background: rgba(220, 38, 38, 0.15);\n    border-color: var(--border-error-subtle);\n    color: var(--color-negative-vivid);\n}\n\n.btn-action-pill--group {\n    width: 48px;\n    height: 28px;\n    border-radius: var(--radius-md);\n}\n\n.btn-action-pill.red:hover {\n    background: rgba(220, 38, 38, 0.3);\n    color: var(--color-text-primary);\n}\n\n.model-builder-table-empty {\n    background: transparent;\n    border-radius: 20px;\n    padding: var(--space-xl);\n    text-align: center;\n    color: var(--color-text-faint);\n    border: 1px dashed var(--border-default);\n    transition: var(--transition-fast);\n}\n\n/* Inner Table Reset */\n.inner-table-body {\n    padding: 0;\n    max-height: none; /* Let the container handle scroll */\n}\n\n/* Custom Scrollbar for All Scrollable Areas (Sub-Products, Main Table, Search Panel) */\n.inner-table-body::-webkit-scrollbar,\n.panel-items::-webkit-scrollbar,\n.model-builder-table-container::-webkit-scrollbar {\n    width: 6px;\n    height: 6px;\n    /* For horizontal scroll if needed */\n    background: transparent;\n}\n\n.inner-table-body::-webkit-scrollbar-track,\n.panel-items::-webkit-scrollbar-track,\n.model-builder-table-container::-webkit-scrollbar-track {\n    background: transparent;\n}\n\n.inner-table-body::-webkit-scrollbar-thumb,\n.panel-items::-webkit-scrollbar-thumb,\n.model-builder-table-container::-webkit-scrollbar-thumb {\n    background: rgba(255, 255, 255, 0.15);\n    border-radius: 3px;\n}\n\n.inner-table-body::-webkit-scrollbar-thumb:hover,\n.panel-items::-webkit-scrollbar-thumb:hover,\n.model-builder-table-container::-webkit-scrollbar-thumb:hover {\n    background: rgba(255, 255, 255, 0.3);\n}\n\n/* Base Glass Input/Select for Table */\n.glass-box-input {\n    background: var(--surface-input);\n    border: 1px solid var(--border-default);\n    border-radius: var(--radius-md);\n    padding: 0.35rem var(--space-sm);\n    color: var(--color-text-primary);\n    font-size: var(--font-size-base);\n    outline: none;\n    width: 100%;\n    transition: var(--transition-fast);\n}\n\n.glass-box-input:focus {\n    border-color: rgba(255, 255, 255, 0.25);\n    background: var(--surface-input-focus);\n}\n\n.glass-box-select {\n    background: var(--surface-input);\n    border: 1px solid var(--border-default);\n    border-radius: var(--radius-md);\n    padding: 0.4rem 0.6rem;\n    color: var(--color-text-primary);\n    font-size: var(--font-size-base);\n    outline: none;\n    cursor: pointer;\n    width: 100%;\n}\n\n.glass-box-select option {\n    background-color: var(--surface-dark-gradient-start);\n    color: var(--color-text-primary);\n    padding: var(--space-sm);\n}\n\n/* ============================================\n   BOTTOM ACTIONS (Inside Border Wrapper)\n   ============================================ */\n.model-builder-actions {\n    display: flex;\n    justify-content: flex-end;\n    gap: var(--space-xl);\n    margin-top: auto;\n    padding: var(--space-lg);\n}\n\n.btn-glass-cancel {\n    padding: 0.6rem var(--space-2xl);\n    background: rgba(185, 28, 28, 0.15);\n    border: 1px solid var(--border-error-subtle);\n    border-radius: var(--radius-lg);\n    color: var(--color-text-primary);\n    font-size: var(--font-size-md);\n    font-weight: 600;\n    cursor: pointer;\n    transition: var(--transition-fast);\n    text-transform: uppercase;\n}\n\n.btn-glass-cancel:hover {\n    background: rgba(185, 28, 28, 0.3);\n    border-color: rgba(220, 38, 38, 0.5);\n}\n\n.btn-glass-save {\n    padding: 0.6rem 2.5rem;\n    background: rgba(76, 29, 149, 0.3);\n    border: 1px solid var(--border-primary);\n    border-radius: var(--radius-lg);\n    color: var(--color-text-primary);\n    font-size: var(--font-size-md);\n    font-weight: 600;\n    cursor: pointer;\n    transition: var(--transition-fast);\n    text-transform: uppercase;\n}\n\n.btn-glass-save:hover {\n    background: rgba(76, 29, 149, 0.5);\n    border-color: var(--border-primary-hover);\n}\n\n/* Base Pill Dropzone */\n.dropzone-pill {\n    flex: 1;\n    border: 1.5px dashed var(--border-medium);\n    border-radius: var(--radius-2xl);\n    height: 48px;\n    display: flex;\n    align-items: center;\n    justify-content: center;\n    margin-top: var(--space-lg);\n}\n\n/* ============================================\n   RESPONSIVE\n   ============================================ */\n@media (max-width: 1200px) {\n    .model-builder-container {\n        flex-direction: column;\n        height: 95vh;\n    }\n\n    .component-search-panel {\n        width: 100%;\n        min-width: auto;\n        max-height: 250px;\n    }\n\n    .panel-items {\n        flex-direction: row;\n        flex-wrap: wrap;\n    }\n\n    .panel-item {\n        flex: 0 0 calc(33.33% - 0.5rem);\n    }\n}\n\n.glass-pill-input:disabled, .glass-pill-select:disabled { opacity: 0.5; cursor: not-allowed; pointer-events: none; }\n\n\n\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
